import { CellValueChangedEvent, ColDef } from '@ag-grid-community/core';
import { DocLineUpdatedDto, StockDocDto } from '@digiwall/goliath-documents/proxy';
import { Observable, of, OperatorFunction } from 'rxjs';
import { LocalizationService, Rest } from '@abp/ng.core';
import StockDocLinesEditorComponent from '../../../../stock-doc-lines-editor.component';
import { BaseDocServiceForLineEditor } from '../../../../../../components/lines-editor/base-doc-line-editor/base-doc-line-editor';
import { IStockDocService } from '../../../../../../components';
import {
  ArticleSerialDto,
  ArticleSerialService,
  ArticleService,
} from '@digiwall/goliath-products/proxy';
import { InputSignal } from '@angular/core';
import { LabelPrinterHelper } from '@digiwall/goliath-products';

export interface StockLinePolicy {
  get addPurchaseData(): boolean;
  enhanceColDefs(colDefs: ColDef[]): ColDef[];
  onCellValueChanged(e: CellValueChangedEvent): Observable<any> | boolean;
  beforeAddArticleLine(): Observable<DocLineUpdatedDto | null>;
  beforeSaveDoc(): Observable<DocLineUpdatedDto | null>;
  onLineAdded(): void;
  beforeSaveLine(): void;
  onUnsavedLineChanged(response: DocLineUpdatedDto): DocLineUpdatedDto;
  focusOnNewLine(): boolean;
  getAddArticleLineFn(): (
    docId: string,
    order: number,
    lineFromId: string,
    config?: Partial<Rest.Config>,
  ) => Observable<DocLineUpdatedDto>;
}

export interface IStockMovementService extends IStockDocService {
  setLineUnitPrice(
    docId: string,
    docConcurrencyStamp: string,
    lineId: string,
    unitPrice: number,
    config?: Partial<Rest.Config>,
  ): Observable<DocLineUpdatedDto>;

  addArticleLineSerialEntry(
    docId: string,
    lineId: string,
    articleId: string,
    locationId: string,
    input: ArticleSerialDto,
    config?: Partial<Rest.Config>,
  ): Observable<DocLineUpdatedDto>;

  selectSerialWithdrawal(
    docId: string,
    lineId: string,
    serialNumber: string,
    config?: Partial<Rest.Config>,
  ): Observable<DocLineUpdatedDto>;
  addWithdrawalArticleLine(
    docId: string,
    reference: number,
    lineFromId: string,
    config?: Partial<Rest.Config>,
  ): Observable<DocLineUpdatedDto>;
}

export interface IStockMovementLinesEditorComponent {
  copyLineData: InputSignal<boolean>;
  printLabel: InputSignal<boolean>;
  stockArticleService: ArticleService;
  stockArticleSerialService: ArticleSerialService;
  stockLocalizationService: LocalizationService;
  stockIsBusyAdding(value: boolean): void;
  stockColDefs: ColDef[];
  stockLabelPrinterHelper: LabelPrinterHelper;
}

export class StockDocMovementPolicy<
  T extends StockDocLinesEditorComponent<TDoc, TService> & IStockMovementLinesEditorComponent,
  TDoc extends StockDocDto,
  TService extends BaseDocServiceForLineEditor & IStockMovementService,
> implements StockLinePolicy
{
  constructor(private ctx: T) {}

  get addPurchaseData() {
    return true;
  }

  enhanceColDefs(colDefs: ColDef[]): ColDef[] {
    return colDefs;
  }

  onCellValueChanged(event: CellValueChangedEvent): Observable<any> | boolean {
    switch (event.column.getColId()) {
      case 'unitPrice':
        return this.ctx.stockDocService.setLineUnitPrice(
          this.ctx.document.id,
          this.ctx.document.concurrencyStamp,
          event.data.id,
          event.data.unitPrice,
        );
      default:
        return true;
    }
  }

  beforeAddArticleLine(): Observable<DocLineUpdatedDto | null> {
    return of(null);
  }

  getAddArticleLineFn(): (
    docId: string,
    order: number,
    lineFromId: string,
    config?: Partial<Rest.Config>,
  ) => Observable<DocLineUpdatedDto> {
    return this.ctx.stockDocService.addArticleLine;
  }

  beforeSaveDoc(): Observable<DocLineUpdatedDto | null> {
    return of(null);
  }

  onLineAdded(): void {}

  beforeSaveLine(): void {}

  onUnsavedLineChanged(response: DocLineUpdatedDto): DocLineUpdatedDto {
    return response;
  }

  focusOnNewLine() {
    return true;
  }
}
